<template>
  <div id="update-data-page" v-if="site">
    <h2 class="intro-y text-lg font-medium mt-10">
      更改{{ site.name }}的職能名稱
    </h2>

    <role-form v-if="mounted && checkPermission(permissions, 'system.role.edit')" :site="site" :data="data"></role-form>
    <div v-else-if="mounted">
      <div class="alert alert-danger show mt-2" role="alert">沒有權限查看</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['auth', 'permissions'],
  data() {
    return {
      mounted: false,
      site: null,
      data: null
    }
  },
  watch: {
    auth(val) {
      if (val) {
        this.init()
      }
    },
    permissions() {
      this.init()
    }
  },
  async mounted() {
    if (!this.auth) {
      return
    }

    await this.init()
  },
  methods: {
    async init() {
      if (this.permissions) {
        await this.loadSite()
        await this.loadData()

        setTimeout(() => {
          this.mounted = true
        }, 500)
      }
    },
    async loadSite() {
      this.site = await this.getSite(this.$route.params.siteId)
    },
    async loadData() {
      this.data = await this.getRole(this.$route.params.roleId)
    }
  }
}
</script>

<style lang="scss" scoped></style>
